import Vue from 'vue';
import VueRouter from 'vue-router';
import UniqueId from 'vue-unique-id';
import VueExpandableImage from 'vue-expandable-image';
import VueScrollto from 'vue-scrollto';
import BootstrapVue from 'bootstrap-vue';
import RouterPrefetch from 'vue-router-prefetch';
import App from './App';
import router from './routes/index';
import TFCC from './plugins/tfcc';
import VueGtag from "vue-gtag";
Vue.config.productionTip = false;

//vue-tag google analytics
Vue.use(VueGtag, {
    config: { id: "G-19HXGCZ1LG" }
  }, router);
Vue.use(TFCC);
Vue.use(BootstrapVue);
Vue.use(VueRouter);
Vue.use(RouterPrefetch);
Vue.use(UniqueId);
Vue.use(VueExpandableImage);
Vue.use(VueScrollto);

/* eslint-disable no-new */
new Vue({
    router,
    render: h => h(App)
}).$mount("#app");